import { Component, DestroyRef,inject,EventEmitter, Inject,ElementRef, Input, OnInit, Optional, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import * as SharedModels from '@shared-models/index';
import { ImageService } from '@ui-app/services/image.service';
import { ICroppPhotoRequestOld, UPLOAD_URL } from '@shared-models/common.models';
import { FileUploadService } from '@ui-app/components/file-upload/file-upload.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from '@ui-app/components/spinner/spinner.service';
import { BaseModal } from '@ui-app/modals/base-modal';
import { ApiConfig } from '@employee-configs/api.config';
import { filter, switchMap } from 'rxjs/operators';
import { IBoundingBox, IPrehireBadgeRequestDetailsResponse } from '@employee-models/data.models';
import Cropper from 'cropperjs';
 
import { CustomModalService } from '@ui-app/services/custom-modal.service';
import { ConfirmModalComponent } from '@ui-app/modals/confirm-modal/confirm-modal.component';
import { AutomaticCroppingService } from '@ui-app/services/automatic-cropping.service';
import { Observable, takeUntil } from 'rxjs';
import { BadgeRequestsService } from '../../core/services/data-access/badge-requests.service';
import { EPhotoReviewMode, IAllCropperData, ICropperViewData } from '../prehire-photo-review-modal/cropper.models';
import {BadgeReasonEnum, BadgeRequestCategoryEnum} from '@employee-models/data.enums';
import { BadgeStatusEnum, PhotoStatusEnum } from '../../models/data.enums';
import { Router } from '@angular/router';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'employee-prehire-photo-review-modal',
    templateUrl: './prehire-photo-review-modal.component.html',
    styleUrls: ['./prehire-photo-review-modal.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class PrehirePhotoReviewModalComponent extends BaseModal implements OnInit {
 
    @Input() prehireDetails: IPrehireBadgeRequestDetailsResponse;
    @Input() buttonsTitle = { dismiss: 'Close' };
    //@ViewChild('image', { static: false }) imageElement;
    @ViewChild('image', { static: false }) imageElement: ElementRef<HTMLImageElement>;
    @Input() badgeRequestReasonId: BadgeReasonEnum;
    @Input() badgeRequestCategoryId: BadgeRequestCategoryEnum;
    @Input() badgeRequestStatusId: BadgeStatusEnum;
    @Input() photoRequestStatusId: PhotoStatusEnum;
    // Change @Output to @Input for onPhotoUpdated
    @Input() onPhotoUpdated: () => void; 
    isApproveAndDeclineButton = false;
    isFurtherReviewButton = false;
    @Input() onApprovePhotoCallback: () => void = () => { this.closeModal(); };
    @Input() onDeclinePhotoCallback: () => void = () => { this.closeModal(); };
    @Input() onFurtherReviewCallback: () => void = () => { this.closeModal(); };
    imageSource: string;
    originalPhotoGuidUrl: string;
    isVisibleEditPhotoBtn: boolean;
    cropper: Cropper;
    outputImage: string;
    isCorrectData = false;
    isDirty = false;
    currentMode: EPhotoReviewMode = EPhotoReviewMode.view;
    cropperSettings: Cropper.Options<HTMLImageElement>;
    minSizeOriginalPhoto: ICropperViewData = {
        width: 250,
        height: 375
    };
    isValidBadgeSts: boolean;
    isValidPhotoSts: boolean;
    isValidFurtherReviewPhotoSts: boolean;
    isPhotoApproved = false;
    isPhotoDeclined = false;

    isFurtherReviewClicked = false;
    get isEditMode(): boolean {
        return this.currentMode === EPhotoReviewMode.edit;
    }
 
    get getCropperViewData(): ICropperViewData {
        const data = this.cropper ? this.cropper.getData() : {} as ICropperViewData;
        return {
            width: data.width ? Math.trunc(data.width) : 0,
            height: data.height ? Math.trunc(data.height) : 0,
        };
    }
 
    get originalImageSource(): string {
        return this.originalPhotoGuidUrl;
    }
 
    get cropperData(): IAllCropperData {
        return {
            data: this.cropper.getData(),
            cropBoxData: this.cropper.getCropBoxData(),
            canvasData: this.cropper.getCanvasData()
        };
    }
 
    set cropperData(cropperData: IAllCropperData) {
        this.cropper.rotate(cropperData.data.rotate);
        this.cropper.setCropBoxData(cropperData.cropBoxData);
        this.cropper.setCanvasData(cropperData.canvasData);
    }
 
    isImageRecognitionEnabled: boolean;
 
    constructor(
        private http: HttpClient,
        private imageService: ImageService,
        private toasterService: ToastrService,
        private spinnerService: SpinnerService,
        private customModalService: CustomModalService,
        private automaticCroppingService: AutomaticCroppingService,
        private badgeRequestsService: BadgeRequestsService,
        private router: Router, // Inject Router
        @Optional() @Inject(UPLOAD_URL) public uploadUrl: string,
        @Optional() @Inject(FileUploadService) public fileUploadService: FileUploadService
    ) {
        super();
    }
 
    ngOnInit(): void {
       
        if(this.prehireDetails.badgeRequestStatus=='Pending')
            {
              this.isValidBadgeSts = true;
            }
       
            if(this.prehireDetails.photoRequestStatus=='Approval pending' || this.prehireDetails.photoRequestStatus=='Further review')
            {
              this.isValidPhotoSts = true;
            }
       
            if(this.prehireDetails.photoRequestStatus=='Approval pending')
            {
              this.isValidFurtherReviewPhotoSts = true;
            }
       
          this.isApproveAndDeclineButton = this.isValidPhotoSts && this.isValidBadgeSts;
          this.isFurtherReviewButton = this.isValidBadgeSts && this.isValidFurtherReviewPhotoSts;
       
           // Set the flags based on the photoRequestStatus
           this.isPhotoApproved = this.prehireDetails.photoRequestStatus=='Approved';
           this.isPhotoDeclined = this.prehireDetails.photoRequestStatus=='Resubmission pending';
 
        if (this.prehireDetails.photoGuid) {
            this.subs = this.badgeRequestsService.getDownloadUrl(this.prehireDetails.photoGuid).subscribe(photoGuid => {
                //const elementId = 'viewImage_' + this.prehireDetails.badgeRequestId;
                const element = document.getElementById('viewImage_'+this.prehireDetails.badgeRequestId);
                if (element) {
                    const srcValue = element.getAttribute('src') ?? '';
                    console.log(srcValue);
                    this.imageSource = srcValue;
                }
                else
                this.imageSource = photoGuid.url;
            });
        }
       
        if (this.prehireDetails.originalPhotoGuid) {
            this.subs = this.badgeRequestsService.getDownloadUrl(this.prehireDetails.originalPhotoGuid)
                .subscribe((originalPhotoGuid) => {
                this.originalPhotoGuidUrl = originalPhotoGuid.url;
            });
        }
        this.subs = this.automaticCroppingService.getSetting().subscribe((settings) => {
            this.isImageRecognitionEnabled = settings.isImageRecognitionEnabled;
        });

    }
 

    onPhotoReview(): void {
        this.spinnerService.next(true);
        this.initCropperSettings(this.prehireDetails.croppInfo);
        this.togglePhotoReviewModalMode();
    }
 
    cropperInit(img: any): void {
        this.cropper = new Cropper(img, this.cropperSettings);
    }
 
    savePhotoFirstStep(request: ICroppPhotoRequestOld, dataUrl: string): Observable<any> {
        if (this.isImageRecognitionEnabled) {
            return this.automaticCroppingService
                .changeSizeAndCropPhoto(request, dataUrl, this.uploadUrl);
        }
        return this.fileUploadService
        .uploadFile(this.imageService.fromDataUrlToFile(dataUrl, 'filename'), this.uploadUrl)
        .pipe(
            switchMap((response) => {
                return this.http.post(`${ApiConfig.ImageRekognition.croppPhoto}`, {...request, uId: response.uId});
            }),
        );
    }
 
    savePhoto(): void {
        const request = {
            badgeRequestId: this.prehireDetails.badgeRequestId,
            croppInfo: JSON.stringify(this.cropperData),
            isAutocropped: false,
            uId: null
        };
        this.prehireDetails.croppInfo = request.croppInfo;
    
        const dataUrl = this.cropper.getCroppedCanvas().toDataURL('image/png');
        this.imageSource = dataUrl;

    
        this.subs = this.savePhotoFirstStep(request, dataUrl)
            .subscribe(
                __ => {
                    // Use ViewChild to update the image element
                    if (this.imageElement && this.imageElement.nativeElement) {
                        this.imageElement.nativeElement.src = dataUrl;
                    } else {
                        console.error('Image element not found.');
                    }
    
                    this.toasterService.success('Photo was cropped');
                    if (this.onPhotoUpdated) {
                        this.onPhotoUpdated(); // Call the parent-provided function
                    }
                    this.closeModal();
                    
                },
                __ => {
                    this.toasterService.error('Photo can\'t be changed. Please refresh the page and try again');
                    this.closeModal();
                }
            );
    }
 
    private closeModal(): void {
        this.customModalService.closeModal(PrehirePhotoReviewModalComponent);
    }
 
    onResetToOriginal(): void {
        this.subs = this.customModalService.initModal(ConfirmModalComponent, {
            description: 'Results of cropping will be deleted. Are you sure you want to reset photo to original?'
        })
            .pipe(filter((isConfirmed: boolean) => isConfirmed))
            .subscribe(() => {
                this.resetCroppPhoto();
            });
    }
 
    resetCroppPhoto(): void {
        const request = {
            badgeRequestId: this.prehireDetails.badgeRequestId,
            uId: this.prehireDetails.originalPhotoGuid,
            croppInfo: null
        };
        this.prehireDetails.croppInfo = null;
       
        this.subs = this.http.post(`${ApiConfig.ImageRekognition.croppPhoto}`, request).pipe(
            switchMap(_ => {
                // Call the second API after the first one completes
                return this.badgeRequestsService.getDownloadUrl(this.prehireDetails.photoGuid);
            }),
           
        ).subscribe(
            photoGuid => {
                if (photoGuid) {
                    this.imageSource = photoGuid.url;
                    const element = document.getElementById('viewImage_' +this.prehireDetails.badgeRequestId);
                    if (element) {
                        const srcValue = element.getAttribute('src') ?? '';
                        console.log(srcValue);
                        this.imageSource = srcValue;
                    }
                    this.toasterService.success('Photo was reset to original');
                    if (this.onPhotoUpdated) {
                        this.onPhotoUpdated(); // Call the parent-provided function
                    }
                    this.closeModal();
                    
                }
                this.closeModal();
            },
            error => {
                this.toasterService.error('Photo can\'t be changed. Please refresh the page and try again');
               this.closeModal();
            }
        );
    }
 
    rotate(degree: number): void {
        this.cropper.rotate(degree);
        this.isDirty = true;
        this.checkIsDisabledSavePhotoBtn();
    }

    private togglePhotoReviewModalMode(): void {
        this.currentMode = this.isEditMode ? EPhotoReviewMode.view : EPhotoReviewMode.edit;
        this.spinnerService.next(false);
    }

    private initCropperSettings(cropperData: IBoundingBox | string): void {
        cropperData = null;
        this.cropperSettings = {
            background: true,
            dragMode: 'move',
            aspectRatio: 2 / 3,
            autoCropArea: 1,
            autoCrop: true,
            modal: true,
            guides: true,
            center: true,
            scalable: true,
            zoomable: true,
            cropBoxMovable: true,
            cropBoxResizable: true,
            checkCrossOrigin: false,
            ready: () => {
                
                if (cropperData) {
                    if (typeof cropperData === 'string') {
                        this.cropperData = JSON.parse(cropperData);
                    } else {
                        const imageData = this.cropper.getImageData();
                        const canvasData = this.cropper.getCanvasData();
 
                        this.cropper.setCropBoxData({
                            top: canvasData.top + (imageData.height * cropperData.top),
                            left: canvasData.left + (imageData.width * cropperData.left),
                            height: imageData.height * cropperData.height,
                            width: imageData.width * cropperData.width
                        });
                    }
 
                    this.checkIsDisabledSavePhotoBtn();
                }
 
                this.spinnerService.next(false);
            },
            cropend: () => {
                this.isDirty = true;
                this.checkIsDisabledSavePhotoBtn();
            },
            zoom: () => {
                this.isDirty = true;
                this.checkIsDisabledSavePhotoBtn();
            }
        };
    }
 
    private checkIsDisabledSavePhotoBtn(): void {
        setTimeout(_ => {
            this.isCorrectData = this.isDirty
                && this.getCropperViewData.width >= this.minSizeOriginalPhoto.width
                && this.getCropperViewData.height >= this.minSizeOriginalPhoto.height;
        }, 0);
    }
}
